// Вставка рекламных карточек в список статей (гид §2.9): после карточки номер after_index (0 — после первой);
// after_index за концом списка — в конец. Кому и что показывать, решает сервер (ставки — не в Индии и т. п.).
import type { NewsAd, NewsCard } from '../api/leagueTypes';

export type NewsEntry = { kind: 'article'; article: NewsCard } | { kind: 'ad'; ad: NewsAd };

export function withAds(articles: NewsCard[], ads: NewsAd[] | undefined): NewsEntry[] {
  const last = articles.length - 1;
  const at = (ad: NewsAd) => Math.min(Math.max(ad.slot.after_index ?? last, 0), last);
  const out: NewsEntry[] = [];
  articles.forEach((article, i) => {
    out.push({ kind: 'article', article });
    for (const ad of ads ?? []) if (at(ad) === i) out.push({ kind: 'ad', ad });
  });
  return out;
}

/** Реклама хаба по секциям: ключ секции → её карточки. */
export function adsForSection(ads: NewsAd[] | undefined, section: string): NewsAd[] {
  return (ads ?? []).filter((a) => a.slot.section === section);
}

/** Реклама полотна «Матчи»: после блока дня after_day. */
export function adsForDay(ads: NewsAd[] | undefined, date: string): NewsAd[] {
  return (ads ?? []).filter((a) => a.slot.after_day === date);
}
